import { defaultErrorMap } from 'zod';
/** 요청 계약 Zod 실패 전용. 비즈니스 카탈로그에 넣지 않는다. */
export const REQUEST_INVALID_CODE = 'REQUEST_INVALID';
/** `REQUEST_INVALID`만 가린다. 비즈니스 코드와 섞어 쓰지 않기 위해서다. */
export function isApiRequestInvalidCode(value) {
    return value === REQUEST_INVALID_CODE;
}
/**
 * Zod issue 배열을 계약 `issues`로 좁힌다.
 * 기본 영어 문구와 flatten dump는 제품 토스트로 쓰지 않기 위해 버린다.
 */
export function toRequestInvalidIssues(issues) {
    if (!Array.isArray(issues)) {
        return [];
    }
    const mapped = [];
    for (const raw of issues) {
        const shape = readIssueShape(raw);
        if (!shape) {
            continue;
        }
        const issue = { path: shape.path, code: shape.code };
        // 스키마가 직접 쓴 문구만 남긴다. 기본 영어는 필드 UI 사전으로 대체한다.
        if (shape.message && !isZodDefaultMessage(shape.record)) {
            issue.message = shape.message;
        }
        mapped.push(issue);
    }
    return mapped;
}
/**
 * 클라이언트가 받은 `issues`를 계약 형태로만 남긴다.
 * 서버가 이미 고른 `message`는 유지하고, `expected`/`received` 같은 dump만 버린다.
 */
export function parseRequestInvalidIssues(value) {
    if (!Array.isArray(value)) {
        return undefined;
    }
    const mapped = [];
    for (const raw of value) {
        const shape = readIssueShape(raw);
        if (!shape) {
            continue;
        }
        const issue = { path: shape.path, code: shape.code };
        // 서버가 실어 보낸 계약 문구는 기본 영어와 다시 비교하지 않는다.
        if (shape.message) {
            issue.message = shape.message;
        }
        mapped.push(issue);
    }
    return mapped.length > 0 ? mapped : undefined;
}
/**
 * path와 Zod issue code만 남긴다.
 * dump 필드는 여기서 잘라 계약 밖으로 나가지 않게 한다.
 */
function readIssueShape(raw) {
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
        return undefined;
    }
    const record = raw;
    if (typeof record.code !== 'string' || record.code.length === 0) {
        return undefined;
    }
    const path = Array.isArray(record.path)
        ? record.path.filter((segment) => {
            return typeof segment === 'string' || typeof segment === 'number';
        })
        : [];
    const shape = { path, code: record.code, record };
    if (typeof record.message === 'string' && record.message.length > 0) {
        shape.message = record.message;
    }
    return shape;
}
/**
 * Zod 기본 에러 맵과 같은 문장이면 스키마가 쓰지 않은 영어다.
 * 비교가 실패하면 기본 영어를 제품 문구로 오인하지 않도록 버린다.
 */
function isZodDefaultMessage(issue) {
    try {
        const mapped = defaultErrorMap(issue, {
            data: undefined,
            defaultError: 'Invalid input',
        });
        return mapped.message === issue.message;
    }
    catch {
        return true;
    }
}
//# sourceMappingURL=request-invalid.js.map